import { useTranslation } from 'next-i18next';

import {
  PRODUCT_TAG_3_YEAR_RESALE_AGREEMENT,
  PRODUCT_TAG_4_YEAR_RESALE_AGREEMENT,
  PRODUCT_TAG_5_YEAR_RESALE_AGREEMENT,
  PRODUCT_TAG_COA_2_YEAR_DISPATCH,
  PRODUCT_TAG_COA_3_YEAR_DISPATCH,
  PRODUCT_TAG_COA_4_YEAR_DISPATCH,
  PRODUCT_TAG_COA_5_YEAR_DISPATCH,
} from '../constants/product';
import { ResaleAgreement } from '../utils/resaleAgreement/resaleAgreement';

interface Props {
  address?: string;
  firstName: string;
  lastName: string;
  productTags: string[];
  productTitle: string;
}

export const useResaleAgreement = ({
  address,
  firstName = '',
  lastName = '',
  productTags = [],
  productTitle = '',
}: Props) => {
  const { t } = useTranslation('product');

  let coaDeliveryMessage = '';
  let period = 2; // resale agreement period in years

  if (productTags.includes(PRODUCT_TAG_COA_2_YEAR_DISPATCH)) {
    coaDeliveryMessage = t('coaMessage', { count: 2 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_3_YEAR_DISPATCH)) {
    coaDeliveryMessage = t('coaMessage', { count: 3 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_4_YEAR_DISPATCH)) {
    coaDeliveryMessage = t('coaMessage', { count: 4 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_5_YEAR_DISPATCH)) {
    coaDeliveryMessage = t('coaMessage', { count: 5 });
  }

  if (productTags.includes(PRODUCT_TAG_3_YEAR_RESALE_AGREEMENT)) {
    period = 3;
  }

  if (productTags.includes(PRODUCT_TAG_4_YEAR_RESALE_AGREEMENT)) {
    period = 4;
  }

  if (productTags.includes(PRODUCT_TAG_5_YEAR_RESALE_AGREEMENT)) {
    period = 5;
  }

  return ResaleAgreement.get(
    productTitle,
    firstName,
    lastName,
    address,
    coaDeliveryMessage,
    period,
  );
};
